var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7059 15.9528H1.65647C1.38343 15.9114 0.842308 15.645 0.862165 14.9102V1.45675C0.862165 1.16716 1.04088 0.592949 1.75576 0.612807H13.3228C13.6206 0.654179 14.2015 0.905713 14.1419 1.58087V9.44942",
    stroke: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1171 3.46729H15.8795C16.1277 3.47556 16.6341 3.6609 16.6738 4.33605V9.47419",
    stroke: "#7C8092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59967 8.90332H10.0463",
    stroke: "#7C8092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55005 11.0132H8.95411",
    stroke: "#7C8092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55005 13.3213H7.39033",
    stroke: "#7C8092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39399 16.002V17.7891C3.37744 18.087 3.49328 18.6927 4.08901 18.7324H8.50731",
    stroke: "#7C8092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34436 3.36816V6.07376",
    stroke: "#7C8092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90814 2.82178V6.07345",
    stroke: "#7C8092"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52161 4.48486V6.02382",
    stroke: "#7C8092"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9185,
    cy: 14.8603,
    r: 3.14883,
    stroke: "#7C8092"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4504 17.4912L18.3617 19.4521",
    stroke: "#7C8092"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.454 14.8356L13.4965 15.8781L15.234 14.1157",
    stroke: "#7C8092"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.b4ad939bf6b933fcce49100a64a195aa.svg";
export { ForwardRef as ReactComponent };